import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';

import {Statistics} from '../model/statistics.interface';
import {AccountService} from './account.service';
import {AdminService} from './admin.service';

@Injectable()
export class StatisticResolve implements Resolve<Statistics> {
  constructor(
    private accountService: AccountService,
    private adminService: AdminService,
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {

    return state.url.includes('admin') ?
      this.adminService.getStatistics() :
      this.accountService.getStatistics();
  }
}



// WEBPACK FOOTER //
// ./src/app/services/statistics.resolve.ts